import select from './directives/select';

export default angular.module('edge.platform.widgets.select', [])
    .directive('gwPlSelect', select);